import { openFacebookShare, openTwitterShare, openMailShare, openWhatsAppShare, openTelegramShare } from "../../../widgetsUtils";
const clickOutside = require("react-click-outside");

interface ShareMenuProps {
    title: string
    shareUrl: string
    articleId?: string
    className?: string
    btnTitle?: string
    isDefaultOpen?: boolean
    isMobileWeb?: boolean
    isApp?: boolean
    showPrint?: boolean
    showCopyLink?: boolean
    showTelegram?: boolean
    showAndroidShare?: boolean
    onShare?: (platform: string) => void
}

interface ShareMenuState {
    isMenuOpened: boolean
    isCopied: boolean
}

declare let window: Window & {
    languageCode: string
}

@clickOutside
export class ShareMenu extends React.Component<ShareMenuProps, ShareMenuState> {

    private copiedTimeout: any = null;

    constructor(props) {
        super(props);
        this.state = {
            isMenuOpened: props.isDefaultOpen || false,
            isCopied: false,
        };
    }

    componentWillUnmount() {
        if (this.copiedTimeout) {
            clearTimeout(this.copiedTimeout);
        }
    }

    private handleClickOutside = () => {
        this.setState({ isMenuOpened: false });
    }

    private handleShareBtnClick = (platform: string) => {
        if (typeof window === "undefined") {
            return;
        }
        const { shareUrl, title, articleId, onShare } = this.props;
        const articleIdOrNull = articleId ? articleId : null;

        if (onShare) {
            onShare(platform);
        }

        switch (platform) {
            case "fb":
                openFacebookShare(shareUrl, "", null, "Article", articleIdOrNull);
                break;
            case "tw":
                openTwitterShare(shareUrl, null, "Article", articleIdOrNull);
                break;
            case "mailto":
                openMailShare(title, "", shareUrl, null, "Article", articleIdOrNull);
                break;
            case "wa":
                openWhatsAppShare(shareUrl, null, "Article", articleIdOrNull);
                break;
            case "print":
                window.print();
                break;
            case "tg":
                openTelegramShare(shareUrl, onShare ? () => onShare("tg") : undefined);
                break;
            case "android-share":
                this.openNativeShare();
                break;
        }
    }

    private handleCopyLink = async () => {
        const { shareUrl, onShare } = this.props;
        const urlToCopy = shareUrl || (typeof window !== "undefined" ? window.location.href : "");

        try {
            if (navigator.clipboard && navigator.clipboard.writeText) {
                await navigator.clipboard.writeText(urlToCopy);
            } else {
                const textarea = document.createElement("textarea");
                textarea.value = urlToCopy;
                textarea.style.position = "absolute";
                textarea.style.left = "-9999px";
                textarea.style.opacity = "0";
                textarea.setAttribute("readonly", "true");
                document.body.appendChild(textarea);
                textarea.select();
                document.execCommand("copy");
                document.body.removeChild(textarea);
            }
        } catch (err) {
            console.error("Failed to copy link:", err);
        }

        if (onShare) {
            onShare("copyLink");
        }

        this.setState({ isCopied: true });
        this.copiedTimeout = setTimeout(() => {
            this.setState({ isCopied: false });
        }, 2500);
    }

    private openNativeShare = async () => {
        const { title, shareUrl, isApp } = this.props;
        if (isApp) {
            location.href = "share_article";
            return;
        }
        try {
            // @ts-ignore
            await navigator.share({ url: shareUrl, title: title });
        } catch (err) {
            console.error("Native share failed:", err);
        }
    }

    private handleToggleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        const { isMobileWeb, isApp } = this.props;
        if (isMobileWeb || isApp) {
            this.openNativeShare();
        } else {
            this.setState({ isMenuOpened: !this.state.isMenuOpened });
        }
    }

    render() {
        const { isMenuOpened, isCopied } = this.state;
        const { className, btnTitle, isDefaultOpen, isMobileWeb, isApp, showPrint, showCopyLink, showTelegram, showAndroidShare } = this.props;

        if (isMobileWeb || isApp) {
            return (
                <div
                    className={`share-menu-mobile-trigger${className ? ` ${className}` : ""}`}
                    onClick={this.handleToggleClick}
                />
            );
        }

        return (
            <div className={`share-menu${isMenuOpened ? " opened" : ""}${className ? ` ${className}` : ""}`}>
                <div className="share-menu-toggle" onClick={this.handleToggleClick}>
                    {!isDefaultOpen && <span className="share-menu-icon" />}
                    {btnTitle && <span className="share-menu-title">{btnTitle}</span>}
                </div>

                <div className="share-menu-btns">
                    {showPrint && (
                        <button
                            className="share-icon print"
                            title="הדפסה"
                            onClick={() => this.handleShareBtnClick("print")}
                        />
                    )}
                    {showCopyLink && (
                        <div className="share-copy-link-wrapper">
                            {isCopied && <span className="share-copied-feedback">הקישור הועתק</span>}
                            <button
                                className={`share-icon copy-link${isCopied ? " copied" : ""}`}
                                title="העתקת קישור"
                                onClick={this.handleCopyLink}
                            />
                        </div>
                    )}
                    <button className="share-icon mailto" title="שליחה במייל" onClick={() => this.handleShareBtnClick("mailto")} />
                    <button className="share-icon tw" title="שיתוף באקס" onClick={() => this.handleShareBtnClick("tw")} />
                    <button className="share-icon fb" title="שיתוף בפייסבוק" onClick={() => this.handleShareBtnClick("fb")} />
                    <button className="share-icon wa" title="שיתוף בוואטסאפ" onClick={() => this.handleShareBtnClick("wa")} />
                    {showTelegram && (
                        <button className="share-icon tg" title="שיתוף בטלגרם" onClick={() => this.handleShareBtnClick("tg")} />
                    )}
                    {showAndroidShare && (
                        <button className="share-icon android-share" title="שיתוף" onClick={() => this.handleShareBtnClick("android-share")} />
                    )}
                </div>
            </div>
        );
    }
}
